import { render, staticRenderFns } from "./JobPreviewContentPieData.vue?vue&type=template&id=181b1c50&scoped=true"
import script from "./JobPreviewContentPieData.vue?vue&type=script&lang=js"
export * from "./JobPreviewContentPieData.vue?vue&type=script&lang=js"
import style0 from "./JobPreviewContentPieData.vue?vue&type=style&index=0&id=181b1c50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181b1c50",
  null
  
)

export default component.exports